module.exports = __webpack_public_path__ + "img/sec-221-sangsangin.5c7e54bd.svg";